import { Waterform, Productionform, Socialform, Form } from "../../api";
import { waterCodes, waterKPIsCodes, waterFormulasIndicators, convertUnitsFinal } from "./waterForms";
import { computeRealKpiValue } from "./kpiRealValue";

const waterController = new Waterform();
const productionController = new Productionform();
const socialController = new Socialform();
const formController = new Form();

const CODE_TO_FIELD = Object.fromEntries(
  Object.entries(waterKPIsCodes).map(([field, code]) => [code, field])
);

const RAW_FIELDS = Object.keys(waterCodes);

/** Lee el valor REAL de un KPI de Agua (sitio + año). Ver kpiRealValue.js. */
export async function getRealWaterKpiValue({ accessToken, site, kpiCode, year }) {
  const fieldKey = CODE_TO_FIELD[kpiCode];
  if (!fieldKey) return { available: false, reason: "unknown_kpi" };

  return computeRealKpiValue({
    accessToken,
    site,
    year,
    fieldKey,
    rawFields: RAW_FIELDS,
    formulasFn: waterFormulasIndicators,
    convertFn: convertUnitsFinal,
    getRecordsFn: (t, s, ys) => waterController.getWaterFormsByLastYears(t, s, ys),
    recordsWrapperKey: "waterForms",
    getUnitsFn: (t, s, y, f) => waterController.getLastUnitFieldsByYear(t, s, y, f),
    getBaselineFn: (t, s, y) => productionController.getTotalBaselineByYearAndSite(t, s, y, "standardized_production"),
    getWorkersFn: (t, s, ys) => socialController.getTotalWorkersByYears(t, s, ys),
    getConfigFn: (t, s, moduleName, active) => formController.getFormsBySite(t, s, moduleName, active),
    moduleName: "water",
  });
}
